
import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AttivitaStore } from 'src/app/pages/features/distribuzione-censimento/attivita/attivita.store';
import { CondominiStore } from 'src/app/pages/features_shared/anagrafica-soggetti-utenze-condomini/condomini/condomini.store';
import { SoggettiStore } from 'src/app/pages/features_shared/anagrafica-soggetti-utenze-condomini/soggetti/soggetti.store';
import { UtenzaStore } from 'src/app/pages/features_shared/anagrafica-soggetti-utenze-condomini/utenze/utenza.store';

export const resetStoreGuard: CanDeactivateFn<any> = () => {
  const utenzaStore = inject(UtenzaStore);
  const soggettiStore = inject(SoggettiStore);
  const condominiStore = inject(CondominiStore);
  const attivitaStore = inject(AttivitaStore);
  utenzaStore.clearTableData();
  soggettiStore.clearTableData();
  condominiStore.clearTableData();
  attivitaStore.clearTableData();
  return true;
};
